<script>
  import { onMount } from 'svelte';
  import Button from '@ui/pico/button.svelte';
  import {
    getAuth,
    linkWithCredential,
    GoogleAuthProvider,
    EmailAuthProvider,
    sendSignInLinkToEmail,
    linkWithPopup,
  } from 'firebase/auth';

  import { firebaseAuth, user, ux } from '../../store';
  import { goto } from '../../util';
  import { supportedEmailLoginMethods } from '../../util/auth';
  import { pages } from '../../config';
  import { updateAuthUser } from '../../services';
  import FaIcon from '../components/fa-icon.svelte';

  export let params;

  let email = '';
  const settings = {
    url: window.location.href + '/verify',
    handleCodeInApp: true,
  };

  onMount(() => {
    if ($user && $user.email) {
      return goto(pages.dashboard.url);
    }
    if (params.mode === 'signIn') {
      const auth = getAuth();
      auth.onAuthStateChanged(async (u) => {
        if (u) {
          console.log('user', u);
          const res = await linkEmailToGuest(u);
          try {
            console.info('link result', res);
          } catch (error) {
            console.warn('link error', error);
          }
        }
      });
    }
  });

  async function authenticate() {
    console.info('authenticate.start', email);
    if (!supportedEmailLoginMethods(email, 'email/link')) {
      console.warn(
        'Cannot authenticate with email link since not allowed for this user'
      );
      return;
    }

    console.info('authenticate.sendSignInLinkToEmail', email, settings);
    const res = await sendSignInLinkToEmail($firebaseAuth, email, settings);
    $ux.emailLinkRes = res;
    $ux.emailForSignIn = email;
    goto(pages.entry.waiting.url);
  }

  async function linkEmailToGuest(u) {
    console.log('linkEmailToGuest.start', u);
    // Construct the email link credential from the current URL.
    const credential = EmailAuthProvider.credentialWithLink(
      email,
      settings.url
    );

    console.log('linkEmailToGuest.cred', credential);
    // Link the credential to the current user.
    try {
      // The provider is now successfully linked.
      // The phone user can now sign in with their phone number or email.
      console.log('linkEmailToGuest.linkWithCredential');
      const usercred = await linkWithCredential(u, credential);
      console.info({ usercred });
    } catch (error) {
      console.log('linkEmailToGuest.error', error);
      console.warn('authenticate error', error);
    }
  }

  function backToDashboard() {
    goto(pages.dashboard.url);
  }
  async function googleLogin() {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    let linkedUser;

    // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
    provider.addScope('https://www.googleapis.com/auth/userinfo.email');
    provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

    try {
      linkedUser = await linkWithPopup(auth.currentUser, provider);
      if (linkedUser) {
        const cu = auth.currentUser;
        const [pd] = cu?.providerData || [];

        $user = {
          ...$user,
          ...linkedUser.user,
          photoURL: cu.photoURL || pd.photoURL,
          displayName: pd.displayName,
          providerId: pd.providerId,
          phoneNumber: pd.phoneNumber,
        };
      }
    } catch (error) {
      console.error(error);
      console.warn('failed to link account');
    }

    if (!linkedUser) return console.warn('No linked user');

    const updateRes = await updateAuthUser();
    if (updateRes.status === 200) {
      window.location = pages.dashboard.url;
    }
  }

  // function liLogin() {
  //   alert('Linkedin login coming soon');
  // }
  // function githubLogin() {
  //   alert('Github login coming soon');
  // }
  // function gitlabLogin() {
  //   alert('GitLab login coming soon');
  // }
</script>

<dialog open>
  <article>
    <header>
      <a
        on:click={backToDashboard}
        href="#close"
        aria-label="Close"
        class="close"
      >
        &nbsp;
      </a>
    </header>
    {#if params.mode === 'signIn'}
      <hgroup>
        <h2>Completing Account Linking</h2>
        <h4>One moment please</h4>
      </hgroup>

      <progress />
    {:else}
      <form on:submit|preventDefault={authenticate}>
        <hgroup>
          <h2>Complete Registration</h2>
          <h4>A code will be sent to you for access</h4>
        </hgroup>

        <input
          autofocus
          bind:value={email}
          required
          type="email"
          placeholder="you@your-domain.com"
        />
        <Button type="submit" class="secondary" iconLeft="mail" iconSize={32}>
          Send Login Link
        </Button>
        <Button class="google icon-button" on:click={googleLogin}>
          <FaIcon size={22} />
          <div style="border:solid transparent;padding: 0 0.4rem;">Google</div>
        </Button>
        <!-- <Button class="linkedin icon-button" on:click={liLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">LinkedIn</div>
        <FaIcon social="linkedin" size={22} />
      </Button>
      <Button class="github icon-button" on:click={githubLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">Github</div>
        <FaIcon social="github" size={22} />
      </Button>
      <Button class="gitlab icon-button" on:click={gitlabLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">Github</div>
        <FaIcon social="gitlab" size={22} />
      </Button> -->
      </form>
    {/if}
  </article>
</dialog>

<style>
  :global(.icon-button span) {
    display: flex;
    flex-direction: row;
  }
  :global(.github) {
    background: #333;
  }
  :global(.gitlab) {
    background: #fc6d26;
  }
  :global(.google) {
    background: #0f9d58;
    background: #db4437;
    background: #f4b400;
    background: #4285f4;
  }
  :global(.linkedin) {
    background: #0077b5;
  }
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }
  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
